import React from "react";

export default function SQLServer_PATINDEX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_PATINDEX</h1>
      <p>This is the SQLServer_PATINDEX component generated from the SQL JSON.</p>
    </div>
  );
}
